import Api from '@/utils/api'
import BasicConfig from '@/config/basic'
import dayjs from 'dayjs'

// 获取护理预警列表
export function getNursingAlerts (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/alerts/nursing`, { params: { ...query, axiosType: 'python' } })
}

// 获取护理预警明细
export function getNursingAlertsDetail (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/alerts/nursing_profile`, { params: { ...query, axiosType: 'python' } })
}

// 获取产康预警列表
export function getPostpartumAlerts (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/alerts/postpartum`, { params: { ...query, axiosType: 'python' } })
}

//  获取店务预警列表
export function getStoreAlerts (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/alerts/store`, { params: { ...query, axiosType: 'python' } })
}
//  获取到家预警列表
export function getHomeAlerts (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/alerts/home_service`, { params: { ...query, axiosType: 'python' } })
}

// 监控预警：按设备+通道分组的未处理列表（Java）
// 长连接场景下与 SSE 互补：HTTP 基线列表的断网/休眠恢复强制刷新由
// monitoringGroupUnprocessedSlice + @/utils/reconnectManager 注册，勿在业务页重复挂 online/visibility
export function getMonitoringGroupUnprocessed (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/alarm/monitoring/group_unprocessed`, { params: { ...query, axiosType: 'java' } })
}

/**
 * 监控预警时段统计（Java）
 * GET /alarm/monitoring/statistics
 * data.slots[]: slot, hours, total, processed, unprocessed
 * @param {Object} query
 * @param {string|number} [query.storeId] 门店
 */
export function getMonitoringStatistics (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/alarm/monitoring/statistics`, { params: { ...query, axiosType: 'java' } })
}

/**
 * 监控告警历史/明细列表（Java）
 * GET /alarm/monitoring
 * @param {Object} query
 * @param {string} query.deviceId 设备序列号
 * @param {string|number} query.channelNo 通道号
 * @param {number} query.startTime 开始时间戳（毫秒）
 * @param {number} query.endTime 结束时间戳（毫秒）
 * @param {boolean} [query.isProcessed] 是否已处理
 */
export function getMonitoringAlarms (query = {}) {
  const params = {
    ...query,
    axiosType: 'java'
  }
  if (params.isProcessed === undefined || params.isProcessed === null || params.isProcessed === '') {
    delete params.isProcessed
  }
  return Api.get(`${BasicConfig.jDomain}/alarm/monitoring`, { params })
}

// 设置警告备注
export function setWarningRemark(data) {
  return Api.put(`${BasicConfig.jDomain}/alarm/monitoring/set_remark`, {
    ...data,
    axiosType: 'java'
  })
}

/**
 * 监控 Webhook 推送记录（Java）
 * GET /alarm/monitoring/logs
 * @param {Object} query
 * @param {string} [query.deviceId] 设备序列号
 * @param {string} [query.channelNo] 通道号
 * @param {string} [query.messageType] 消息类型
 * @param {number|string} [query.startTime] 开始时间（毫秒时间戳或 YYYY-MM-DD HH:mm:ss）
 * @param {number|string} [query.endTime] 结束时间（毫秒时间戳或 YYYY-MM-DD HH:mm:ss）
 * @param {string} [query.orderBy] 排序字段（如 create_time、update_time）
 * @param {string} [query.orderDirection] asc | desc
 * @param {number} [query.pageNumber] 页码（从 1 开始）
 * @param {number} [query.pageSize] 每页条数
 */
function toMonitoringLogEpochMs (raw) {
  if (raw == null || raw === '') return undefined
  const d = dayjs(raw)
  if (!d.isValid()) return undefined
  return d.valueOf()
}

export function getMonitoringLogs (query = {}) {
  const params = { ...query, axiosType: 'java' }
  const startTime = toMonitoringLogEpochMs(params.startTime)
  const endTime = toMonitoringLogEpochMs(params.endTime)
  if (startTime != null) {
    params.startTime = startTime
  } else {
    delete params.startTime
  }
  if (endTime != null) {
    params.endTime = endTime
  } else {
    delete params.endTime
  }
  return Api.get(`${BasicConfig.jDomain}/alarm/monitoring/logs`, { params })
}

/**
 * 监控 Webhook 推送记录标记误判（Java）
 * PUT /alarm/monitoring/logs/mark_false_positive
 * @param {Object} body
 * @param {string|number} body.id 记录 id
 * @param {string} [body.falsePositiveReason] 误判说明（可选）
 */
export function markMonitoringLogFalsePositive (body = {}) {
  const { id, falsePositiveReason } = body
  if (id == null || id === '') {
    return Promise.reject(new Error('id 不能为空'))
  }
  const payload = {
    id,
    axiosType: 'java'
  }
  const reason = falsePositiveReason == null ? '' : String(falsePositiveReason).trim()
  if (reason) {
    payload.falsePositiveReason = reason
  }
  return Api.put(`${BasicConfig.jDomain}/alarm/monitoring/logs/mark_false_positive`, payload)
}